// extracted by mini-css-extract-plugin
export default {"belowMainNav":"Root_belowMainNav__bO5De","mainSection":"Root_mainSection__td8Nr"};